<template>
  <div :class="$style.wrap">
    <div :class="$style.footerNav">
      <div
        v-for="(item, index) in footerList"
        :key="index"
        @click="selectFooter(item.path, index)"
      >
        <van-icon
          :class="[$style.icon, footerIndex == index && $style.icon_active]"
          :name="item.iconName"
        />
        <span
          :style="{ color: footerIndex == index ? '#48d5af' : '#818181' }"
          >{{ item.title }}</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "service",
  data() {
    return {
      footerIndex: this.$ls.get("footerIndex", 0),
      footerList: [
        {
          title: "游戏专区",
          routerName: this._anchor.gameHome.name,
          path: this._anchor.gameHome.path,
          icon: "icon-game",
          iconName: "apps-o"
        },
        {
          title: "账号申诉",
          routerName: this._anchor.appealSubmit.name,
          path: this._anchor.appealSubmit.path,
          icon: "icon-appeal",
          iconName: "description"
        }
        // {
        //   title: "客服电话",
        //   routerName: this._anchor.tel.name,
        //   path: this._anchor.tel.path,
        //   icon: "icon-phone",
        //   iconName: "service-o"
        // }
      ]
    };
  },
  watch: {
    $route: {
      handler: function(val) {
        if (!val) return false;
        this.footerList.forEach((item, index) => {
          if (val.name === item.routerName) {
            this.footerIndex = index;
            this.$ls.set("footerIndex", this.footerIndex);
          }
        });
      },
      // 深度观察监听
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapActions(["SetLeave", "SetGame"]),
    /**
     * @description 底部路径选择
     * @param {string} path  - 路径
     * @param {string} index - 索引
     */
    selectFooter(path, index) {
      this.footerIndex = index;
      this.SetGame("");
      this.$ls.set("footerIndex", this.footerIndex);
      if (this.$route.name == "appealSubmit") {
        this.$parent.resetAppealSumbit();
      } else {
        this.SetLeave(true);
      }

      this.$router.replace(path);
    }
  }
};
</script>
<style lang="less" module>
.wrap {
  position: relative;
  background-color: #efeff4;
  .footerNav {
    .size(100%, 1rem);
    .flex-center();
    .flex-around();
    max-width: 7.5rem;
    position: fixed;
    bottom: 0;
    background-color: #ffffff;
    & > div {
      .flex-align-center();
      .flex-col();
      .icon {
        font-size: 0.38rem;
        color: #818181;
        &_active {
          color: rgb(72, 213, 175);
        }
      }

      span {
        margin-top: 0.08rem;
        font-size: 0.25rem;
        color: #818181;
      }
    }
  }
}
</style>
